import { Fragment } from "react";
import styled from "styled-components/macro";
import { useFields } from "../../hooks/use-fields";
import { IconButton } from "../Button";
import { Plus } from "../Icons";
import Condition from "./Condition";
import { BoxConnector } from "../Box";
import Tooltip from "../Tooltip";
import { newCondition } from "./factories";

function Conditions({ value, onChange, renderLogicToggle }) {
  const { field, value: conditions } = useFields({ value, onChange });

  const addNew = () => {
    onChange((conditions) => [...conditions, newCondition()]);
  };

  const remove = (index) => () => {
    onChange((conditions) =>
      conditions.map((item, i) =>
        i !== index ? item : { ...item, _destroy: true }
      )
    );
  };

  const canRemove =
    conditions.filter((condition) => !condition._destroy).length > 1;

  return (
    <>
      {conditions.map((item, index) =>
        item._destroy ? null : (
          <Fragment key={item.tempId || item.id}>
            {conditions.slice(0, index).some((item) => !item._destroy) && (
              <>
                <BoxConnector />
                <Center>{renderLogicToggle(index)}</Center>
                <BoxConnector />
              </>
            )}
            <Condition
              {...field(index)}
              onRemove={canRemove ? remove(index) : undefined}
            />
          </Fragment>
        )
      )}
      {conditions.filter((c) => !c._destroy).length > 0 && <BoxConnector />}
      <Center>
        <Tooltip label="Add Condition">
          <IconButton onClick={() => addNew()}>
            <Plus />
          </IconButton>
        </Tooltip>
      </Center>
    </>
  );
}

export default Conditions;

const Center = styled.div`
  text-align: center;
`;
